import { useMemo, useState } from 'react';

const START_HTML = `<main class="card">
  <h1>Hello from WebSurf Sandbox</h1>
  <p>Edit HTML, CSS, and JavaScript. The preview updates live.</p>
  <button id="demo">Click me</button>
</main>`;
const START_CSS = `body{font-family:system-ui;margin:0;display:grid;place-items:center;min-height:100vh;background:#10131a;color:white}.card{padding:32px;border:1px solid rgba(255,255,255,.18);border-radius:24px;background:rgba(255,255,255,.08)}button{border:0;border-radius:999px;padding:10px 14px}`;
const START_JS = `document.getElementById('demo').addEventListener('click', () => alert('Sandbox running'));`;

export function HtmlSandbox() {
  const [html, setHtml] = useState(START_HTML);
  const [css, setCss] = useState(START_CSS);
  const [js, setJs] = useState(START_JS);
  const [tab, setTab] = useState<'html' | 'css' | 'js'>('html');
  const srcDoc = useMemo(() => `<!doctype html><html><head><style>${css}</style></head><body>${html}<script>${js.replace(/<\/script/gi, '<\\/script')}</script></body></html>`, [html, css, js]);

  return (
    <div className="sandbox-view">
      <div className="sandbox-editor">
        <div className="panel-tabs">
          <button className={tab === 'html' ? 'active' : ''} onClick={() => setTab('html')}>HTML</button>
          <button className={tab === 'css' ? 'active' : ''} onClick={() => setTab('css')}>CSS</button>
          <button className={tab === 'js' ? 'active' : ''} onClick={() => setTab('js')}>JS</button>
        </div>
        {tab === 'html' && <textarea value={html} onChange={(event) => setHtml(event.target.value)} spellCheck={false} />}
        {tab === 'css' && <textarea value={css} onChange={(event) => setCss(event.target.value)} spellCheck={false} />}
        {tab === 'js' && <textarea value={js} onChange={(event) => setJs(event.target.value)} spellCheck={false} />}
      </div>
      <iframe title="HTML sandbox live preview" srcDoc={srcDoc} sandbox="allow-scripts allow-modals allow-forms" />
    </div>
  );
}
